import React, {Component, Fragment} from 'react';
import {Link, withRouter} from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import {Button} from "reactstrap";
import * as QueryStringUtil from "utils/QueryStringUtil";

const CUSTOMER_CARE_NUMBER = process.env.REACT_APP_CUSTOMER_CARE_NUMBER;

class PaymentRedirect extends Component {


    constructor(props, context) {
        super(props, context);
        this.state = {
            success: this.props.match.params.success === "success"
        }
    }

    render() {
        return <Fragment>
            <div className={"stitchRedirectContainer"}>
                {this.getMessage()}
                <Link to={"/transactions"}>
                    <Button color="primary">OK</Button>
                </Link>
            </div>
        </Fragment>
    }

    getMessageWithPaymentInfo() {
        let accepted = QueryStringUtil.getQueryStringValue("accepted")
        let paymentReference = QueryStringUtil.getQueryStringValue("paymentReference")
        let amount = QueryStringUtil.getQueryStringValue("amount")

        return <Fragment>
            <div className={"stitchMessageWithPaymentInfo"}>
                {accepted === 'true' ?
                    <Fragment>
                        <i className="fa fa-check-circle fa-3x text-success" aria-hidden="true"></i>&nbsp;&nbsp;
                        <span style={{
                            padding: 10
                        }}>
                            Payment of R{amount} was successful for payment reference {paymentReference}.
                        </span>
                    </Fragment>
                    :
                    <Fragment>
                        <i className="fa fa-times-circle fa-3x text-danger" aria-hidden="true"></i>&nbsp;&nbsp;
                        <span style={{
                            padding: 10
                        }}>
                            Failed to complete payment for reference {paymentReference}. Please retry the payment or contact our customer service on {CUSTOMER_CARE_NUMBER}.
                        </span>
                    </Fragment>
                }
            </div>
        </Fragment>
    }

    getMessage() {
        return <Fragment>
            <div className={"stitchPaymentRedirectMessage"}>
                {
                    this.state.success ? <Fragment>
                            <i className="fa fa-check-circle fa-3x text-success" aria-hidden="true"></i>&nbsp;&nbsp;
                            <span style={{
                                padding: 10
                            }}>
                            Your payment was successfully submitted.
                        </span>
                        </Fragment>
                        : <Fragment>
                            <i className="fa fa-times-circle fa-3x text-danger" aria-hidden="true"></i>&nbsp;&nbsp;
                            <span style={{
                                padding: 1
                            }}>
                            Your payment was NOT submitted.
                        </span>
                        </Fragment>
                }
            </div>
        </Fragment>;
    }

}

export default withRouter(PaymentRedirect);
